import { AxiosResponse } from "axios";
import api from "./client";
import { getEmail, getStoredUser } from "./currentUser";

// Consent names for dropdowns (uses tenant_id from logged-in user)
export const getConsentNames = (): Promise<AxiosResponse> =>
  api.get("/consent-notice/names", {
    params: { tenant_id: getStoredUser().tenant_id },
  });

// Tenant list (MyConsents page)
export const getTenantConsents = (params?: Record<string, unknown>): Promise<AxiosResponse> =>
  api.get("/user/tenant-consents", {
    params: { email: getEmail(), ...params },
  });

// Consent list under a tenant (ConsentList page)
export const getConsentsByTenant = (
  tenant_id: string,
  params?: Record<string, unknown>,
): Promise<AxiosResponse> => api.get("/user/consents", { params: { tenant_id, ...params } });

// Consent statuses for filter dropdown
export const getConsentStatuses = (tenant_id: string): Promise<AxiosResponse> =>
  api.get("/user/consent-statuses", { params: { tenant_id } });

// Update selected purposes for a consent (marks it GRANTED)
export const updateConsentPreferences = (
  tenant_id: string,
  consent_id: string,
  selected_purposes: unknown,
  consent_status: string,
  notice_version?: string,
): Promise<AxiosResponse> =>
  api.post("/user/update-preferences", {
    tenant_id,
    consent_id,
    selected_purposes,
    consent_status,
    notice_version,
  });

export const withdrawAllConsent = (
  tenant_id: string,
  consent_id: string,
  selected_purposes: unknown,
  notice_version?: string,
): Promise<AxiosResponse> =>
  api.post("/user/withdraw-consent", {
    tenant_id,
    consent_id,
    selected_purposes,
    consent_status: "WITHDRAWN",
    notice_version,
  });

// Consent data (per consent)
export const getConsentData = (consentId: string): Promise<AxiosResponse> =>
  api.get(`/consents/${consentId}/data`);
